import OrderBook from './OrderBook';
import connect from './connect';

export default connect(OrderBook);



// WEBPACK FOOTER //
// ./src/components/OrderBook/index.js